import { useState } from "react";
import {
  Announcement,
  ObserveRefreshData,
  Vehicle,
} from "../../../../../types/observe";
import "./SoundSelect.scss";
import { audioPresetPlay } from "../../../../../utils/sendData";

interface SoundSelectProps {
  refreshData: ObserveRefreshData | null;
  announcement: Announcement[];
  observeCC: string | null;
  vehicle: Vehicle | null;
  sendData: (msg: object) => void;
  onModalOpen: (message: string) => void;
}

const SoundSelect = ({
  refreshData,
  announcement,
  observeCC,
  vehicle,
  sendData,
  onModalOpen,
}: SoundSelectProps) => {
  const [selectedCd, setSelectedCd] = useState("");
  const isSelecting = refreshData?.info?.is_selecting;
  const announcementPlaying = refreshData?.info?.is_announcement_playing;
  const sr = observeCC;
  const dt = vehicle?.vehicle_communication_code;

  const handlePlay = () => {
    if (!sr || !dt) return;

    if (!selectedCd) {
      onModalOpen("固定音声を選択してください");
      return;
    }

    const audioSwitching = refreshData?.info?.audio_switching;
    const voiceSwitching = refreshData?.info?.voice_switching;

    if (
      audioSwitching !== "0" &&
      audioSwitching !== "1" &&
      audioSwitching !== "2"
    ) {
      onModalOpen("車内音声または車外音声を選択してください。");
      return;
    }

    if (audioSwitching === "0" && voiceSwitching !== "2") {
      onModalOpen("車内音声または車外音声を選択してください。");
      return;
    }

    const selectedAnnouncement = announcement.find(
      (a) => a.announcement_cd === selectedCd
    );

    if (!selectedAnnouncement) {
      onModalOpen("選択された音声データが見つかりません。");
      return;
    }

    const audioPreset = Number(selectedCd);
    const pri = Number(selectedAnnouncement.priority ?? 3);
    const vol = Number(selectedAnnouncement.volume ?? 2);
    const voicebtn = audioSwitching === "1" ? 1 : 2;
    const announcementCount =
      announcementPlaying === "1"
        ? 0
        : Number(selectedAnnouncement.announcement_count ?? 1);

    sendData(
      audioPresetPlay(
        sr,
        dt,
        audioPreset,
        pri,
        vol,
        voicebtn,
        announcementCount
      )
    );
  };

  return (
    <div className="soundSelectArea">
      <div className="title">固定音声</div>
      <div className="buttonWrapper">
        <select
          className="disablebtn"
          value={selectedCd}
          onChange={(e) => setSelectedCd(e.target.value)}
        >
          <option value="">選択してください</option>
          {announcement.map((a, index) => (
            <option
              key={`${a.announcement_cd}-${index}`}
              value={a.announcement_cd}
            >
              {a.announcement}
            </option>
          ))}
        </select>
        <button
          type="button"
          disabled={isSelecting !== "1"}
          onClick={handlePlay}
        >
          {announcementPlaying === "1" ? "停止" : "再生"}
        </button>
      </div>
    </div>
  );
};

export default SoundSelect;
